<template>
    <cadastro-v2 v-if="$app.nome_divulgacao == 'GestãoClick' || $app.nome_divulgacao == 'ClickNotas'" />

    <externo classe="col col-sm-10" v-else>
        <div id="cadastro-contabil">
            <cadastro-v1>
                <template #chamada>
                    <h3 class="text-dark text-center text-uppercase mb-4">Cadastre sua contabilidade</h3>
                </template>
            </cadastro-v1>
        </div>
    </externo>
</template>

<script>
import CadastroV1 from '@/modules/parceiro/domains/cadastro/components/Cadastro'
import CadastroV2 from '@/modules/parceiro/domains/cadastro/components/CadastroV2'
export default {
    components: {
        CadastroV1,
        CadastroV2
    }
}
</script>
<style>
#cadastro-contabil h4 {
    font-size: 1.12rem;
    color: #121212;
}
#cadastro-contabil label {
    color: #212121;
}
a.small {
    font-size: 12.5px;
}
</style>
